import httpApiApplication from 'app/http/httpApiApplication';
const baseUrl = 'documents';
const baseReportUrl = 'reports';
export const uploadFile = (values: any, name?: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  return httpApiApplication.postCfg(baseUrl + '?' + 'name=' + name, values, config);
};
export const downloadFile = (id: string) => {
  return httpApiApplication.get(baseUrl + '/' + id);
};

export const downloadTaxpayerReport = (id: string) => {
  return httpApiApplication.get(baseReportUrl + '/taxpayer-tax-report-document/' + id);
};
